import { render, staticRenderFns } from "./UserPwd.vue?vue&type=template&id=fb41a4ea&"
import script from "./UserPwd.vue?vue&type=script&lang=js&"
export * from "./UserPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports